module.exports = __webpack_public_path__ + "static/img/11.8dbef7d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/eng/11.png
// module id = haLX
// module chunks = 0